import moment from 'moment';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { WeekDays } from 'dash-common';
import { Box, Flex, FormContext, Text, WorkingHoursInput } from 'dash-ui';

import { FormFields } from 'pages/ProfilePage/components/AccountInfo/components/AccountInfoForm/AccountInfoForm.constants';

const WorkingHoursInfo = () => {
  const { t } = useTranslation();
  const { formState, stateHandlers } = useContext(FormContext);
  const weekdays = Object.values(WeekDays);

  const handleTimePickerValue =
    (day: WeekDays) => (value: { from?: string; to?: string }) => {
      stateHandlers[FormFields.WorkingHours]({
        ...formState.workingHours,
        [day]: value,
      });
    };

  const setDefaultWorkingHours = (day: WeekDays) => (checked: boolean) => {
    if (!checked) {
      stateHandlers[FormFields.WorkingHours]({
        ...formState.workingHours,
        [day]: null,
      });
    } else {
      const [defaultFrom, defaultTo] = [
        moment()
          .set({ hour: 5, minute: 0, second: 0, millisecond: 0 })
          .toISOString(),
        moment()
          .set({ hour: 22, minute: 0, second: 0, millisecond: 0 })
          .toISOString(),
      ];

      stateHandlers[FormFields.WorkingHours]({
        ...formState.workingHours,
        [day]: { from: defaultFrom, to: defaultTo },
      });
    }
  };

  return (
    <Box>
      <Text semibold lg>
        {t('forms:labels.workingHours')}
      </Text>
      <Flex w="100%" flexWrap="wrap" justifyContent="space-between" mt={4}>
        {weekdays.map((day, index) => {
          const defaultValue =
            formState.workingHours && formState.workingHours[day];

          return (
            <Box key={day} mb={index !== weekdays.length - 1 ? 8 : 0}>
              <WorkingHoursInput
                withRightIcon={false}
                onChange={handleTimePickerValue(day)}
                label={t(`common:labels.weekDays.${day}`)
                  .slice(0, day === WeekDays.Tuesday ? 4 : 3)
                  .toUpperCase()}
                onSwitch={setDefaultWorkingHours(day)}
                defaultValue={defaultValue}
              />
            </Box>
          );
        })}
      </Flex>
    </Box>
  );
};

export default WorkingHoursInfo;
